export default __webpack_public_path__ + "static/media/arial.e8b1471c.ttf";